import cardBackgroundPs from 'images/background/pokerstars/bg_feedback_card_ps.png';

export const feedbackCardTheme = {
  feedbackCard: {
    backgroundImage: `url(${cardBackgroundPs})`,
    description: {
      fontWeight: `500`,
      fontSize: `20px`,
      maxWidth: `unset`,
    },
    mobile: {
      description: {
        fontSize: `18px`,
        maxWidth: `100px`,
      },
    },
  },
};
